import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { TableContext } from '../../contexts/tableContext';
import styles from './settings.module.scss';

function SettingsLayout() {
  const { dashboardStyle } = useContext(TableContext);
  const { bodyStyle } = useContext(TableContext);

  return (
    <div className={styles[bodyStyle]}>
      <div className={styles[dashboardStyle]} id={styles.dashboardcont2}>
        <div className={styles.settingsection}>
          <div className={styles.settingsTitleRow} id={styles.layoutnav}>
            {/*
            <Nav as="ul" className={`${styles[formthemeStyle]} tabNav`} id={styles.layoutnav}>
              <Nav.Item as="li" className={styles.navitemli}>
                <Link to="/settings" className={styles[settingsgeneralStyle]}>
                  General
                </Link>
              </Nav.Item>
            </Nav>
            */}
            <h2 className={styles.settingsLayoutTitle}>Settings</h2>
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default SettingsLayout;
